import { Moment } from 'moment'

import { ConfigFilterItem, ConfigItem } from 'Core/interfaces'

export enum InboundTrailerFormFields {
	processingCenterId = 'processingCenterId',
	trailerNumber = 'trailerNumber',
	sealNumber = 'sealNumber',
	arrivalDate = 'arrivalDate',
	receiveDate = 'receiveDate',
	serviceSiteId = 'serviceSiteId',
	transporterId = 'transporterId',
	statusId = 'statusId'
}

export enum InboundTrailerSearchFields {
	searchBySealNumber = 'searchBySealNumber',
	searchByTrailerNumber = 'searchByTrailerNumber',
	searchByServiceSiteId = 'searchByServiceSiteId',
	searchByServiceSiteName = 'searchByServiceSiteName',
	searchByTransporterId = 'searchByTransporterId',
	searchByTransporterName = 'searchByTransporterName'
}

export enum InboundTrailerFilterFields {
	arrivalDate = 'arrivalDate',
	receivedDate = 'receivedDate',
	processingCenterId = 'processingCenterId',
	statusId = 'statusId'
}

export declare namespace InboundTrailer {
	interface Basic {
		id: number
		sealNumber: string | null
		trailerNumber: string | null
		arrivalDate: string
		receiveDate: string | null
		serviceSite: NullableEntity | null
		transporter: NullableEntity | null
		processingCenter: NullableEntity | null
		status: Entity | null
	}

	interface InboundSealNumber {
		id: number
		sealNumber: string
		trailerNumber: string
		processingCenter: Entity
		serviceSite: Entity
	}

	namespace Form {
		interface Generic {
			[InboundTrailerFormFields.processingCenterId]: number | null
			[InboundTrailerFormFields.trailerNumber]: string
			[InboundTrailerFormFields.sealNumber]: string
			[InboundTrailerFormFields.arrivalDate]: Moment | null
			[InboundTrailerFormFields.receiveDate]: Moment | null
			[InboundTrailerFormFields.serviceSiteId]: LabelValue<number> | null
			[InboundTrailerFormFields.transporterId]: LabelValue<number> | null
			[InboundTrailerFormFields.statusId]: number | null
		}
	}

	namespace Request {
		interface Generic {
			[InboundTrailerFormFields.processingCenterId]: number
			[InboundTrailerFormFields.trailerNumber]: string
			[InboundTrailerFormFields.sealNumber]: string
			[InboundTrailerFormFields.arrivalDate]: string
			[InboundTrailerFormFields.receiveDate]: string
			[InboundTrailerFormFields.serviceSiteId]: number
			[InboundTrailerFormFields.transporterId]: number
			[InboundTrailerFormFields.statusId]: number
		}
	}

	namespace Search {
		interface Result {
			[InboundTrailerSearchFields.searchBySealNumber]: string[]
			[InboundTrailerSearchFields.searchByTrailerNumber]: string[]
			[InboundTrailerSearchFields.searchByServiceSiteId]: Entity[]
			[InboundTrailerSearchFields.searchByServiceSiteName]: string[]
			[InboundTrailerSearchFields.searchByTransporterId]: number[]
			[InboundTrailerSearchFields.searchByTransporterName]: string[]
		}

		interface Config {
			[InboundTrailerSearchFields.searchBySealNumber]: ConfigItem<InboundTrailerSearchFields>
			[InboundTrailerSearchFields.searchByTrailerNumber]: ConfigItem<InboundTrailerSearchFields>
			[InboundTrailerSearchFields.searchByServiceSiteId]: ConfigItem<InboundTrailerSearchFields>
			[InboundTrailerSearchFields.searchByServiceSiteName]: ConfigItem<InboundTrailerSearchFields>
			[InboundTrailerSearchFields.searchByTransporterId]: ConfigItem<InboundTrailerSearchFields>
			[InboundTrailerSearchFields.searchByTransporterName]: ConfigItem<InboundTrailerSearchFields>
		}
	}

	namespace Filter {
		interface Config {
			[InboundTrailerFilterFields.arrivalDate]: ConfigFilterItem<string, null>
			[InboundTrailerFilterFields.receivedDate]: ConfigFilterItem<string, null>
			[InboundTrailerFilterFields.processingCenterId]: ConfigFilterItem<string, string>
			[InboundTrailerFilterFields.statusId]: ConfigFilterItem<string, string>
		}
	}
}
